module.exports = __webpack_public_path__ + "img/page52.a59a397f.gif";